import { ChangeDependent } from 'domain/usecases/dependents/change-denpendent'
import { DependentsRepository } from 'repository/interfaces/dependents-repositoriy'

export class RemoteChangeDependent implements ChangeDependent {
  private readonly dependentsRepository: DependentsRepository

  constructor(dependentsRepository: DependentsRepository) {
    this.dependentsRepository = dependentsRepository
  }

  update(params: ChangeDependent.Params): Promise<ChangeDependent.Model> {
    return this.dependentsRepository.changeDependent(params)
  }
}

export type ChangePasswordModel = ChangeDependent.Model
